<template>
  <div class="vg-picker">
    <van-popup class="vg-picker-popup" :value="visible" @input="value => $emit('update:visible', value)"  position="bottom" :style="{ height: '80%' }">
      <div class="title">请选择</div>
      <div class="content">
        <div class="item" v-for="(item, index) in items" :key="item.id" @click="onItemClick(index)">
          <div style="flex-grow: 1">
            <div class="item-entry">
              <div class="item-title">项目：</div>
              <div class="item-text" :style="item.isDefault?'color:#4BA9F6':'color:#101010'">{{
                  item.projectName
                }}
              </div>
              <div v-if="isExpired(item.passCardStatus) || isCancelled(item.passCardStatus)" class="expired">
                {{ isExpired(item.passCardStatus) ? "已过期" : "已作废" }}
              </div>
            </div>
            <div class="item-entry">
              <div class="item-title">{{ getTypeTag(item) }}</div>
              <div class="item-text" :style="item.isDefault?'color:#4BA9F6':'color:#101010'">{{ getTypeName(item) }}</div>
            </div>
          </div>
          <div class="item-arrow" v-show="item.isDefault"/>
        </div>
      </div>
      <div class="footer">
        <van-button class="button cancel" @click="onCancel">取消</van-button>
        <van-button class="button" @click="onConfirm">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Button, Popup, Toast} from "vant";

export default {
  name: "VgPassCardPicker",
  components: {
    "van-popup": Popup,
    "van-button": Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {}
  },
  watch: {
    visible() {
      if (this.visible) {
        for (let i = 0; i < this.$props.items.length; i++) {
          this.$props.items[i].isDefault = this.$props.items[i].id === this.id;
        }
      }
    }
  },
  computed: {
    isShow: {
      get() {
        return this.props?.show ?? true;
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },
  },
  emits: {
    "update:show"(val) {
      return val !== undefined;
    }
  },
  methods: {
    onItemClick(index) {
      for (let i = 0; i < this.$props.items.length; i++) {
        this.$props.items[i].isDefault = i === index;
      }
    },
    onCancel() {
      this.isShow = false;
    },
    onConfirm() {
      let select;
      for (let x in this.$props.items) {
        if (this.$props.items[x].isDefault) {
          select = this.$props.items[x];
          break;
        }
      }
      if (!select) {
        Toast.fail("请选择电子出入证");
        return;
      }
      this.isShow = false;
      this.$emit('on-confirm', select);
    },
    isExpired(status) {
      return status === "EXPIRED";
    },
    isCancelled(status) {
      return status === "CANCELLED";
    },
    getTypeTag(item) {
      if (item.passCardType === "TENANT_EMPLOYEE") {
        return "租户名称：";
      } else {
        return "施工位置：";
      }
    },
    getTypeName(item) {
      if (item.passCardType === "TENANT_EMPLOYEE") {
        return item.tenantName;
      } else {
        return item.constructionLocation;
      }
    },
  },
}
</script>

<style scoped>
.vg-picker {
  width: 100%;
}

.vg-picker-popup {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.title {
  margin: 5px;
  font-size: 16px;
  color: #101010;
  align-self: center;
}

.content {
  flex-grow: 1;
  overflow: auto;
}

.item {
  margin: 0px 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EDEBED;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item :last-child {
  border-bottom: none;
}

.checkbox {
  margin-right: 10px;
  flex-shrink: 0;
}

.item-content {
  width: auto;
  display: flex;
  align-items: center;
  justify-content: stretch;
}

.item-entry {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 80px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #4BA9F6;
  flex-grow: 1;
}

.item-arrow {
  margin-left: 15px;
  float: right;
  height: 24px;
  width: 24px;
  background-image: url("@/assets/icon-check.svg");
}

.expired {
  padding: 2px 5px;
  border-radius: 4px;
  background-color: #FF3434;
  color: #FFFFFF;
  font-size: 12px;
  text-align: center;
}

.footer {
  width: 100%;
  margin: 10px 0 15px;
  display: flex;
  justify-content: space-around;
}

.button {
  width: 150px;
  height: 44px;
  border-radius: 3px;
  background-color: #4BA9F6;
  color: #FFFFFF;
  font-size: 16px;
}

.cancel {
  background-color: #B4B4B4;
}

</style>